// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__-misQ","header":"ClearentDisclaimer_header__13on9","inner":"ClearentDisclaimer_inner__23C9T"};